import { useIsV2 } from "../../../common/layout/v2/useIsV2";
import { urls } from "../../../urls";
import type { BidStep } from "./bid/bidWizardSteps";
import type { RequestStep } from "./request/requestWizardSteps";

type StepPath = { pathname: string; search: string };

export interface PortalEventUrls {
  list: string;
  view: {
    go: (eventId: string) => string;
    question: (eventId: string, questionId: string) => string;
    announcement: (eventId: string, announcementId: string) => string;
  };
  bid: { edit: { go: (eventId: string, bidId: string) => Record<BidStep, StepPath> } };
  request: { edit: { go: (eventId: string, requestId: string) => Record<RequestStep, StepPath> } };
}

export const usePortalEventUrls = (): PortalEventUrls => {
  const isV2 = useIsV2();
  if (isV2) {
    return {
      list: urls.v2.supplier.procurements,
      view: urls.v2.supplier.procurement,
      bid: urls.v2.supplier.bid,
      request: urls.v2.supplier.request,
    };
  }
  return {
    list: urls.portal.list,
    view: urls.portal.view,
    bid: urls.portal.bid,
    request: urls.portal.request,
  };
};
